// Booking helper. Opens REACT_APP_CALENDLY_URL in a new tab when set,
// otherwise navigates to the contact page.
const CALENDLY_URL = (process.env.REACT_APP_CALENDLY_URL || "").trim();

export function hasCalendly() {
    return Boolean(CALENDLY_URL);
}

export function getCalendlyUrl() {
    return CALENDLY_URL;
}

export function openBooking(navigate) {
    if (CALENDLY_URL) {
        window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
    } else if (navigate) {
        navigate("/contact");
    } else {
        window.location.assign("/contact");
    }
}
